import React, { Component } from 'react';  
import { hashHistory } from 'react-router';

export default class NullView extends Component {
	state = {
		moveX: 0,
		moveY: 0,
		startX: 0,
		startY: 0,
		endX: 0,
		endY: 0
	}
	componentWillMount() {
		document.addEventListener("touchmove", (event) => {
			event.preventDefault();
		});
	}
	touchStart = (event) => {
		this.setState({
			startX: event.changedTouches[0].pageX,
			startY: event.changedTouches[0].pageY
		});
	}
	touchMove = (event) => {
		let moveX = event.changedTouches[0].pageX - this.state.startX + this.state.endX;
		let moveY = event.changedTouches[0].pageY - this.state.startY + this.state.endY;
		if(moveX >= 0 && moveX <= window.winWidth - 50) {
			this.setState({
				moveX: moveX
			});
		}
		if(moveY >= 0 && moveY <= window.winHeight - 50) {
			this.setState({
				moveY: moveY
			});
		}
	}
	touchEnd = (event) => {
		this.setState({
			endX: this.state.moveX,
			endY: this.state.moveY
		});
	}
    render() {
    	let { moveX, moveY } = this.state;
        return (
            <div style={{width: "100%", height: "100%", background: "#fff", position: "relative", overflow: "hidden"}}>
            	<div onTouchEnd={this.touchEnd} onTouchStart={this.touchStart} onTouchMove={this.touchMove} style={{width: 50, height: 50, background: "red", position: "absolute", left: moveX, top: moveY}}></div>
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/AnimationView.js